import React from "react";
import TopBar from "./header/TopBar";

const Header = () => (
    <>
        <TopBar/>
    </>
);

export default Header;